module.exports = __webpack_public_path__ + "img/detail@2x.30003058.jpg";